exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mr10[data-v-78e8801f]{margin-right:10px}", ""]);

// exports
